import { render, staticRenderFns } from "./termsandconditions.vue?vue&type=template&id=74162d12&scoped=true"
import script from "./termsandconditions.vue?vue&type=script&lang=js"
export * from "./termsandconditions.vue?vue&type=script&lang=js"
import style0 from "./termsandconditions.vue?vue&type=style&index=0&id=74162d12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74162d12",
  null
  
)

/* custom blocks */
import block0 from "./locale/terms-en.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvercel%2Fpath0%2Fpages%2Fother%2Ftermsandconditions.vue&locale=en&external"
if (typeof block0 === 'function') block0(component)
import block1 from "./locale/terms-ar.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fvercel%2Fpath0%2Fpages%2Fother%2Ftermsandconditions.vue&locale=ar&external"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageHero: require('/vercel/path0/components/PageHero.vue').default})
